var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChiefBusinessOfficer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chief-Business-Officer",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,31 L46,31 L46,29 C46,22.265 41.538,16.555 35.415,14.665 C37.573,13.231 39,10.78 39,8 C39,3.589 35.411,0 31,0 C26.589,0 23,3.589 23,8 C23,10.78 24.427,13.231 26.585,14.665 C20.462,16.555 16,22.265 16,29 L16,31 L4,31 C1.794,31 0,32.794 0,35 C0,36.474 0.81,37.75 2,38.444 L2,62 L8,62 L8,58 L54,58 L54,62 L60,62 L60,38.444 C61.19,37.75 62,36.474 62,35 C62,32.794 60.206,31 58,31 Z M32.917,26.52 L31,27.798 L29.083,26.52 L30.659,16.017 C30.773,16.014 30.885,16 31,16 C31.115,16 31.227,16.014 31.341,16.017 L32.917,26.52 Z M25,8 C25,4.691 27.691,2 31,2 C34.309,2 37,4.691 37,8 C37,11.309 34.309,14 31,14 C27.691,14 25,11.309 25,8 Z M18,29 C18,22.651 22.578,17.359 28.604,16.231 L26.917,27.48 L31,30.202 L35.083,27.48 L33.395,16.231 C39.422,17.359 44,22.651 44,29 L44,31 L41,31 L41,23 L39,23 L39,31 L23,31 L23,23 L21,23 L21,31 L18,31 L18,29 Z M4,60 L4,39 L6,39 L6,60 L4,60 Z M8,56 L8,39 L54,39 L54,56 L8,56 Z M58,60 L56,60 L56,39 L58,39 L58,60 Z M58,37 L4,37 C2.897,37 2,36.103 2,35 C2,33.897 2.897,33 4,33 L58,33 C59.103,33 60,33.897 60,35 C60,36.103 59.103,37 58,37 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,41 L14,41 C11.794,41 10,42.794 10,45 C10,47.206 11.794,49 14,49 L24,49 C26.206,49 28,47.206 28,45 C28,42.794 26.206,41 24,41 Z M24,47 L14,47 C12.897,47 12,46.103 12,45 C12,43.897 12.897,43 14,43 L24,43 C25.103,43 26,43.897 26,45 C26,46.103 25.103,47 24,47 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "22 12 20 12 20 4 18 4 18 12 16 12 16 2 14 2 14 12 12 12 12 4 10 4 10 12 8 12 8 6 6 6 6 12 4 12 4 8 2 8 2 12 0 12 0 14 22 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,22 C57.065,22 62,17.065 62,11 C62,4.935 57.065,0 51,0 C44.935,0 40,4.935 40,11 C40,17.065 44.935,22 51,22 Z M51,2 C55.962,2 60,6.038 60,11 C60,15.962 55.962,20 51,20 C46.038,20 42,15.962 42,11 C42,6.038 46.038,2 51,2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,14 C50.449,14 50,13.551 50,13 L48,13 C48,14.302 48.839,15.402 50,15.816 L50,18 L52,18 L52,16 L54,16 L54,13 C54,11.346 52.654,10 51,10 C50.449,10 50,9.551 50,9 L50,8 L51,8 C51.551,8 52,8.449 52,9 L54,9 C54,7.698 53.161,6.598 52,6.184 L52,4 L50,4 L50,6 L48,6 L48,9 C48,10.654 49.346,12 51,12 C51.551,12 52,12.449 52,13 L52,14 L51,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 56,
    y: 10,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 44,
    y: 10,
    width: 2,
    height: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChiefBusinessOfficer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chief-business-officer.858b3ca0.svg";
export { ForwardRef as ReactComponent };